/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionRemotePatientSearchFieldMap } from './PalAuthSubmissionRemotePatientSearchFieldMap';
import {
    PalAuthSubmissionRemotePatientSearchFieldMapFromJSON,
    PalAuthSubmissionRemotePatientSearchFieldMapFromJSONTyped,
    PalAuthSubmissionRemotePatientSearchFieldMapToJSON,
    PalAuthSubmissionRemotePatientSearchFieldMapToJSONTyped,
} from './PalAuthSubmissionRemotePatientSearchFieldMap';

/**
 * 
 * @export
 * @interface PalAuthSubmissionRemotePatientSearchConfig
 */
export interface PalAuthSubmissionRemotePatientSearchConfig {
    /**
     * 
     */
    can_search_remote_patient?: boolean;
    /**
     * 
     */
    category_label?: string;
    /**
     * 
     */
    field_map?: PalAuthSubmissionRemotePatientSearchFieldMap;
}

/**
 * Check if a given object implements the PalAuthSubmissionRemotePatientSearchConfig interface.
 */
export function instanceOfPalAuthSubmissionRemotePatientSearchConfig(value: object): value is PalAuthSubmissionRemotePatientSearchConfig {
    return true;
}

export function PalAuthSubmissionRemotePatientSearchConfigFromJSON(json: any): PalAuthSubmissionRemotePatientSearchConfig {
    return PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionRemotePatientSearchConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'can_search_remote_patient': json['can_search_remote_patient'] == null ? undefined : json['can_search_remote_patient'],
        'category_label': json['category_label'] == null ? undefined : json['category_label'],
        'field_map': json['field_map'] == null ? undefined : PalAuthSubmissionRemotePatientSearchFieldMapFromJSON(json['field_map']),
    };
}

export function PalAuthSubmissionRemotePatientSearchConfigToJSON(json: any): PalAuthSubmissionRemotePatientSearchConfig {
    return PalAuthSubmissionRemotePatientSearchConfigToJSONTyped(json, false);
}

export function PalAuthSubmissionRemotePatientSearchConfigToJSONTyped(value?: PalAuthSubmissionRemotePatientSearchConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'can_search_remote_patient': value['can_search_remote_patient'],
        'category_label': value['category_label'],
        'field_map': PalAuthSubmissionRemotePatientSearchFieldMapToJSON(value['field_map']),
    };
}

